<h2 mat-dialog-title>{{ 'QUERY_DELETE' | transloco }}</h2>
<mat-dialog-content>
  <p>{{ 'QUERY_DELETE_CONFIRM' | transloco }}</p>
  <p>
    <strong>{{ data.name }}</strong>
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="false">{{ 'CANCEL' | transloco }}</button>
  <button mat-flat-button color="warn" [mat-dialog-close]="true">{{ 'QUERY_DELETE' | transloco }}</button>
</mat-dialog-actions>
